module.exports = __webpack_public_path__ + "img/addPicture.7fa657d4.png";